import React, { useState } from 'react';

import { add_reminder_token } from '../../utils/apiOperations';
import { Button } from '../Button';
import { ConfirmAlert } from '../ConfirmAlert';

import './AddReminderToken.scss';

interface AddReminderTokenProps {
  onClose?: any;
  coingeckoid: string;
}

export const AddReminderToken = (props: AddReminderTokenProps) => {
  // use state
  const [targetPrice, setTargetPrice] = useState<string>('');
  const [kind, setKind] = useState<string>('Price down below');
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="add-reminder-token">
      <div id="react-confirm-alert">
        <div className="react-confirm-alert-overlay">
          <div className={`react-confirm-alert-${theme}`}>
            <ConfirmAlert title="Add New Token" onClose={props.onClose}>
              <div className="search-input">
                <input
                  onChange={(e: any) => {
                    setTargetPrice(e.target.value);
                  }}
                  type="text"
                  placeholder="Target price"
                />
              </div>
              <div className="search-input">
                <select
                  onChange={(e: any) => {
                    setKind(e.target.value);
                  }}
                >
                  <option>Price down below</option>
                  <option>Price high above</option>
                </select>
              </div>

              <div className="confirm-button-container">
                <Button color="six" size="large" label="Cancel" onClick={props.onClose} />
                <Button
                  color="one"
                  size="large"
                  onClick={() => {
                    if (targetPrice && kind) {
                      add_reminder_token(props.coingeckoid, targetPrice, kind, props.onClose);
                    }
                  }}
                  label="Add to Reminders"
                />
              </div>
            </ConfirmAlert>
          </div>
        </div>
      </div>
    </div>
  );
};
